import { useState } from 'react'
import { useSiteSettings } from './cms/hooks'

/**
 * Single source of truth for the contact email: SiteSettings.contact.email
 * from the CMS. Returns the address (undefined until the CMS has one), a
 * mailto() builder so every CTA links to the same place, and a click handler
 * that also copies the address — a mailto: link does nothing visible when the
 * browser has no mail client configured.
 */
export function useContactEmail() {
  const { data } = useSiteSettings()
  const email = data?.contact.email
  const [copied, setCopied] = useState(false)

  const mailto = (subject?: string) =>
    email ? `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}` : undefined

  const onCtaClick = () => {
    if (!email) return
    navigator.clipboard?.writeText(email).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2500)
    })
  }

  return { email, mailto, onCtaClick, copied }
}
